var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InteractionHandler } from "../Interactions";
import { LoadRoomMessage, UnloadRoomMessage, EnterRoomMessage, RoomInteraction, RequestLayoutCreationStateMessage, LayoutCreationStateMessage, RoomLoadedStateMessage, RequestRoomLoadedStateMessage, LayoutCreationState, RoomLoadedState, ToastMessage, ButtonType } from "flavr-common";
import { SetControllerButtonDescription } from "../../../messages/controller/ControllerMessages";
export class RoomInteractionHandler extends InteractionHandler {
    constructor() {
        super(RoomInteraction.typestatic, [RoomInteraction.typestatic], [], []);
        this.controllersInfo = new Map();
    }
    isModelSelected(controllerUid, uid) {
        const info = this.controllersInfo.get(controllerUid);
        return (info === null || info === void 0 ? void 0 : info.has(uid)) === true;
    }
    onSelect(params, uid, controller) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!RoomInteraction.is(params))
                return;
            let info = this.controllersInfo.get(controller.uid);
            if (info === undefined) {
                this.controllersInfo.set(controller.uid, (info = new Set()));
            }
            info.add(uid);
            if (params.autoload || params.autoload === undefined) {
                this.connection.send(new LoadRoomMessage(uid, controller.uid));
                this.connection.send(new SetControllerButtonDescription(ButtonType.SELECT, { key: "roomEnter" }, controller.uid));
                return;
            }
            yield this.connection.askByMessageType(new RequestLayoutCreationStateMessage(uid), LayoutCreationStateMessage).then((msg) => {
                if (!this.isModelSelected(controller.uid, uid))
                    return;
                if (msg.state !== LayoutCreationState.Finished) {
                    this.connection.send(new LoadRoomMessage(uid, controller.uid));
                    this.connection.send(new SetControllerButtonDescription(ButtonType.SELECT, { key: "roomEnter" }, controller.uid));
                }
                else {
                    this.connection.send(new SetControllerButtonDescription(ButtonType.SELECT, { key: "roomLoad" }, controller.uid));
                }
            });
        });
    }
    onDeselect(params, uid, controller) {
        if (RoomInteraction.is(params)) {
            const info = this.controllersInfo.get(controller.uid);
            if (info !== undefined) {
                info.delete(uid);
                if (info.size === 0) {
                    this.controllersInfo.delete(controller.uid);
                }
            }
            this.connection.send(new UnloadRoomMessage(uid, controller.uid));
        }
    }
    onSelectButtonClick(params, uid, controller, hitPoint) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!RoomInteraction.is(params))
                return;
            yield this.connection.askByMessageType(new RequestRoomLoadedStateMessage(uid), RoomLoadedStateMessage).then((msg) => {
                if (!this.isModelSelected(controller.uid, uid))
                    return;
                switch (msg.state) {
                    case RoomLoadedState.Loaded:
                        // the room has been loaded so we can enter
                        this.connection.send(new EnterRoomMessage(uid, {
                            position: params.entry_point ? params.entry_point : hitPoint,
                            positionIsInRoomCoordinates: !!params.entry_point
                        }));
                        break;
                    case RoomLoadedState.Loading:
                    case RoomLoadedState.Planned:
                        // the room has not finished loading
                        this.connection.send(new ToastMessage("Room is still loading", "info"));
                        break;
                    case RoomLoadedState.NotLoaded:
                        // loading the room has not yet started.
                        // (should only happen if autoload == false)
                        this.connection.send(new LoadRoomMessage(uid, controller.uid));
                        this.connection.send(new SetControllerButtonDescription(ButtonType.SELECT, { key: "roomEnter" }, controller.uid));
                        break;
                }
            });
        });
    }
}
